module.exports = __webpack_public_path__ + "img/9788957981115.116a8e6c.jpg";